import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import './OpalSamplesFindModal.css';

const OpalSamplesFindModal = ({ show, onHide, search, setSearch }) => {
  const [tempSearch, setTempSearch] = useState(search || '');

  const handleUpdate = () => {
    setSearch(tempSearch);
    onHide();
  };

  return (
    <Modal className="opal-samples-find-modal" show={show} onHide={onHide} centered>
      <Modal.Header>Samples</Modal.Header>
      <Modal.Body>
        <input
          type="text"
          className="form-control"
          placeholder="Search"
          value={tempSearch}
          onChange={e => setTempSearch(e.target.value)}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button className="button-add" onClick={handleUpdate}>
          Update
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default OpalSamplesFindModal;
